// Copyright (c) 2020 Comsearch, Inc., All rights reserved

import { castToFloat } from 'helpers/reduxFormFunctions'

import compareRegulatoryValues from './compareRegulatoryValues'
import compareSiteValues from './compareSiteValues'

// NOTE - this assumes that the initial and submitted segment end values are
// looking at the same segment end id

const compareSegmentEndValues = (initialSegmentEndValues, submittedSegmentEndValues) => {
  // NOTE - this shouldn't ever happen in production!
  // This is here so that if we ever run in to such an error, we have clear messaging
  // that tells us where to look for a bug. Otherwise this could be a tricky one to track down.
  if (
    castToFloat(initialSegmentEndValues.segmentEndId) === null ||
    castToFloat(submittedSegmentEndValues.segmentEndId) === null ||
    initialSegmentEndValues.segmentEndId !== submittedSegmentEndValues.segmentEndId) {
    throw new Error('Callsign Cascade 2 trigger comparison error. Cannot compare two different segment ends for cascade. This is a UI bug.')
  }

  const oldTriggeredValues = {
    ...compareRegulatoryValues(initialSegmentEndValues, submittedSegmentEndValues),
    ...compareSiteValues(initialSegmentEndValues, submittedSegmentEndValues),
  }

  return (
    Object.keys(oldTriggeredValues).length > 0
      ? ({
        segmentEndId: initialSegmentEndValues.segmentEndId,
        oldTriggeredValues,
      })
      : null
  )
}

export default compareSegmentEndValues
